import Vue from "vue";
import Vuex from "vuex";
import mutations from "./mutations";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    isLogin: false,
    anselmUserInfo: null,
    productData: [],
    manualData: [],
    videoData: [],
    synopsisData: [],
    language: "zh",
    defaultSelectMenu: "0",
    aboutContact: null
  },
  mutations,
  actions: {}
});
